// Auth helper functions
export const getAuth0Config = () => ({
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  audience: process.env.REACT_APP_AUTH0_AUDIENCE || 'https://www.user-permissions.com',
  redirectUri: process.env.REACT_APP_AUTH0_REDIRECT_URI || window.location.origin
});

export const loginWithRedirect = (auth0Client, options = {}) => {
  return auth0Client.loginWithRedirect({
    authorizationParams: {
      prompt: 'login',
      ...options.authorizationParams
    },
    ...options
  });
};

export const logout = (auth0Client, returnTo = window.location.origin) => {
  return auth0Client.logout({
    logoutParams: {
      returnTo
    }
  });
};